import { axios } from '@/plugins/axios';
import { CategoryService } from '../common/Category';
import { Exhibitor } from '@/models/exhibitor';

export class ExhibitorService {
  private endpoint: string;
  public categoryService: CategoryService;

  constructor() {
    this.endpoint = 'v1/exhibitors/';
    this.categoryService = new CategoryService(this.endpoint);
  }

  async fetchExhibitors(event: string) {
    return axios
      .get<Exhibitor>(`${this.endpoint}?event=${event}`)
      .then(({ data }) => data);
  }

  async fetchExhibitor(id: number) {
    return axios.get(`${this.endpoint}${id}/`).then(({ data }) => data);
  }

  async createExhibitor(payload: object) {
    return axios.post(`${this.endpoint}`, payload).then(({ data }) => data);
  }

  async updateExhibitor(id: number, payload: object) {
    return axios
      .patch(`${this.endpoint}${id}/`, payload)
      .then(({ data }) => data);
  }

  async deleteExhibitor(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }

  async optionsExhibitor() {
    return axios({ method: 'options', url: `${this.endpoint}` }).then(
      ({ data }) => data
    );
  }
}
